import React from 'react';
import { Trans } from 'react-i18next';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '../Button/Button';
import { PublicImage } from '../PublicImage/PublicImage';
import { ReactComponent as CloseIcon } from '@/assets/icons/actions/close.svg';
import { IPopupMessageDefaultConfig } from '@/store/reducers';
import styles from './PopupMessage.module.scss';

interface IDefaultPopupContentProps {
  config: IPopupMessageDefaultConfig;
  onAction: (animatedClose: () => void) => void;
  onDismiss: (animatedClose: () => void) => void;
  close: () => void;
}

export const DefaultPopupContent: React.FC<IDefaultPopupContentProps> = ({
  config,
  onAction,
  onDismiss,
  close,
}) => (
  <div className={styles.contentWrapper}>
    {config.showCloseButton && (
      <div className={styles.closeButton}>
        <Button
          size={EButtonSize.md}
          hierarchy={EButtonHierarchy.neutral}
          buttonStyle={EButtonStyle.ghost}
          iconLead={CloseIcon}
          onClick={() => onDismiss(close)}
        />
      </div>
    )}
    {config.iconSrc && (
      <PublicImage
        className={styles.icon}
        alt="Popup Message"
        src={config.iconSrc}
      />
    )}
    <div className={styles.textBlock}>
      <div className={styles.title}>
        <Trans i18nKey={config.titleKey} />
      </div>
      <div className={styles.subtitle}>
        <Trans i18nKey={config.subtitleKey} />
      </div>
    </div>
    <Button
      onClick={() => onAction(close)}
      text={config.buttonTextKey}
      fillWidth={true}
      size={EButtonSize.md}
      hierarchy={config.buttonHierarchy ?? EButtonHierarchy.primary}
    />
  </div>
);
